import type { ReactNode } from "react";

export const CONSENT_SCREENSHOT_SRC = "/tiktok-ad-account-management.png";

export const CONSENT_SCREENSHOT_ALT =
  "TikTok's authorization screen, with every field under \u201cAccess Your Ad Account For\u201d ticked and called out as required.";

export const ConnectAdsShell = ({ children }: { children: ReactNode }) => (
  <div className="flex min-h-screen flex-col bg-unbox-cream-25">
    <header className="flex h-14 items-center justify-between gap-4 border-b border-secondary bg-white px-8">
      <img src="/unbox-logo-full.svg" alt="Unbox" className="h-8" />
    </header>
    <main className="flex flex-1 justify-center px-8 py-14">
      <div className="w-full max-w-[1080px]">{children}</div>
    </main>
  </div>
);

export const WhyUnboxNeedsAccess = () => (
  <>
    <div aria-hidden className="mt-7 border-t border-secondary" />
    <h2 className="mt-6 text-md font-medium text-primary">Why Unbox needs access</h2>
    <p className="mt-3 text-sm text-tertiary">
      Unbox needs permission to act on your campaigns, not just read them. That means adding videos to a campaign as
      well as taking them out, excluded from GMV Max or removed from a standard ad campaign, with no manual work in
      TikTok Ads Manager.
    </p>
    <p className="mt-3 text-sm text-tertiary">
      We don't create campaigns or spend on your behalf. What's in them is yours to control. Revoke access any time in
      TikTok for Business.
    </p>
  </>
);
